import { render, staticRenderFns } from "./EmojiEditor.vue?vue&type=template&id=2d1d72ec&scoped=true&"
import script from "./EmojiEditor.vue?vue&type=script&lang=js&"
export * from "./EmojiEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmojiEditor.vue?vue&type=style&index=0&id=2d1d72ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d72ec",
  null
  
)

export default component.exports